import Quill from 'quill';
const BlockEmbed = Quill.import('blots/block/embed') as any;

export class CustomIframeBlot extends BlockEmbed {
  static blotName = 'customIframe';
  static tagName = 'div';
  static className = 'custom-iframe-blot';
  static scope = Quill.import('parchment').Scope.BLOCK;

  static create(url: string): HTMLElement {
    const node = super.create() as HTMLElement;
    node.setAttribute('data-url', url);
    node.setAttribute('contenteditable', 'false');
    node.innerHTML = this.generateEmbedHtml(url);
    return node;
  }

  static value(node: HTMLElement): string {
    return node.getAttribute('data-url') ?? '';
  }

  static generateEmbedHtml(url: string): string {
    const containerStyle = "position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;";
    const iframeStyle = "position: absolute; top: 0; left: 0; width: 100%; height: 100%;";

    if (url.includes('youtube.com')) {
      return `<div style="${containerStyle}"><iframe src="${url}" style="${iframeStyle}" frameborder="0" allowfullscreen></iframe></div>`;
    }

    if (url.includes('firebaseapp.com')) {
      return `<div style="${containerStyle}"><video style="${iframeStyle}" controls><source src="${url}" type="video/mp4"></video></div>`;
    }

    if (url.includes('instagram.com')) {
      return `<div style="${containerStyle}"><iframe src="${url}" style="${iframeStyle}" frameborder="0" allowtransparency="true" allowfullscreen></iframe></div>`;
    }

    if (url.includes('drive.google.com')) {
      const fileID = url.split('/d/')[1]?.split('/')[0];
      const embedURL = `https://drive.google.com/file/d/${fileID}/preview`;
      return `<div style="${containerStyle}"><iframe src="${embedURL}" style="${iframeStyle}" frameborder="0" allowfullscreen></iframe></div>`;
    }

    return `<div style="${containerStyle}"><iframe src="${url}" style="${iframeStyle}" frameborder="0" allowfullscreen></iframe></div>`;
  }
}
